export const openDealerApp = () => {
  if (window.location.pathname.includes('detalhes')) {
    window.open(`dealerapp:/${window.location.pathname}`.replace('detalhes', 'details'), '_self');
  }
};
